/* eslint-disable eag/match-named-export */
import {z} from '@hono/zod-openapi';

import {conversationDetail} from '../../modules/conversation/conversationDetail';

export const getConversationDetailParams = z.object({
  conversationId: z.string().uuid().openapi({
    description: 'ID of requested conversation',
    example: '123e4567-e89b-12d3-a456-426614174000',
  }),
});

export type GetConversationDetailParams = z.infer<typeof getConversationDetailParams>;

export const getConversationDetailResponse = conversationDetail;

export type GetConversationDetailResponse = z.infer<typeof getConversationDetailResponse>;
